import React from 'react'

function Header() {
  return (
    <section className="top-section">
        <h1 className="text-center ">Purchase Parking</h1>
    </section>
  )
}

export default Header
